import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { ArrowRight, Sparkles, Gift } from "lucide-react";

const FinalCTA = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-24 px-4 bg-slate-900 relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/10 to-transparent" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-500/10 rounded-full blur-3xl" />
      
      <div className="relative max-w-4xl mx-auto text-center">
        {/* Beta Badge */}
        <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-4 py-2 mb-6">
          <Gift className="w-4 h-4 text-yellow-400" />
          <span className="text-yellow-400 text-sm font-medium">
            Beta Access — 100% Free for a Limited Time!
          </span>
        </div>
        
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Leap Ahead?
        </h2>
        <p className="text-xl text-slate-400 mb-10 max-w-2xl mx-auto">
          Stop guessing. Start growing. Get your AI-powered brand strategy and 
          leave your competition wondering what happened.
        </p>
        
        <Button
          size="lg"
          onClick={() => navigate("/create")}
          data-testid="final-cta-btn"
          className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-full px-10 py-7 text-lg font-medium shadow-lg shadow-emerald-500/25 transition-all hover:shadow-xl hover:shadow-emerald-500/30 hover:scale-105"
        >
          Generate My Free Strategy
          <ArrowRight className="ml-2 w-5 h-5" />
        </Button>
        
        <p className="text-slate-500 text-sm mt-6">
          Takes less than 2 minutes • No credit card required • Free during beta
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
